import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import Footer from '../Footer';
import Spinner from './as/Spinner';
import { Container, Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ModalExample from './pop'
import './style.css';
import UserTable from "./table2";
import Approver from "./table";
import {Control, LocalForm} from "react-redux-form";
import MyUploader from "../../elements/Upload";
import {config} from "../../../utility/swaggerClient";


const homebox_button = `homebox_button button`;
const panel_home = `panel_home panel`;
let messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'snowflake.home.title',
    description: 'Page Header Title',
    defaultMessage: 'Home'
  },
  headerSubTitle: {
    id: 'empty',
    description: 'Page Header Subtitle',
    defaultMessage: ''
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});
const offerDetails = "<span><b>If you are interested in trying SHIFT Analyzer you can obtain a free Report based on 50K lines of code.                 See below for Terms of Use:</b>\n" +
  "        </span>\n" +
  "          <ul class='marginLeft20'>\n" +
  "            <li>Limited to 1 report per AWS account in a 12-month period (based on your company’s date of registration for SHIFT)</li>\n" +
  "            <li>The free SHIFT Analyzer Report will be limited to 50,000 lines of SQL code</li>\n" +
  "            <ul class='marginLeft20'>\n" +
  "              <li>Based on 90 characters per line standard</li>\n" +
  "            </ul>\n" +
  "            <li>Supported source platform language: Teradata</li>\n" +
  "            <li>Supported target platforms: AWS Redshift</li>\n" +
  "            <li>The free SHIFT Analyzer report will include:</li>\n" +
  "            <ul class='marginLeft20'>\n" +
  "              <li>Automated Translation %</li>\n" +
  "              <li>Source Statement Breakdown</li>\n" +
  "              <li>Automated Translation Breakdown by Object Type</li>\n" +
  "            </ul>\n" +
  "            <li>If the submitted code set exceeds 50,000 lines, the SHIFT Analyzer Report will be based on the first 50,000 lines in the file(s) provided\n" +
  "            </li>\n" +
  "            <li>\n" +
  "              If the submitted code set is less than 50,000 lines, remaining lines of code <i class=\"textUnderline\">cannot be carried</i> over to a subsequent request for a free SHIFT Analyzer report\n" +
  "            </li>\n" +
  "          </ul>"


class Snowflake extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state ={
      show:false,
      userid: "",
      showUpload: false,
      uploadType: "upload",
      projectName: "",
      uploadcontent:"",
      disableUploadBack: false,
      disableupload: false,
      confirmationText: "",
      approvebtn: false,
      reactivatebtn: false,
      deletebtn: false,
      companyname : "",
      modalsize: "modal_sm",
      customer: ""
    }
  }

  componentWillMount() {


    console.log(this.props.customerid);
    console.log(this.props.role);
    if(!this.props.role.includes('ACCOUNT_APPROVER')){
     this.props.gotoDatafactorymanagement();
    }
  }
  componentDidMount() {
    console.log(this.props.role);
    if(this.props.role.includes('ACCOUNT_APPROVER')){
      this.props.getusersList(this.props.username);
    }
    // }else if(this.props.role.includes('PROFESSIONAL_SERVICE') || this.props.role.includes('CUSTOMER_ADMIN')){
    //   this.props.RequestList(this.props.username);
    // }else{
    //   this.props.getCustomers();
    // }


  
  }

  selectItem = (value)=>{
    console.log(value);
    if(value.status === 'DELETED'){
      this.setState({approvebtn : false, reactivatebtn: true, deletebtn: false,userid: value.id });
    }else if(value.status === 'ACTIVE'){
      this.setState({approvebtn : false, reactivatebtn: false, deletebtn: true,userid: value.id });
    }else if(value.status === 'PENDING_APPROVAL'){
      this.setState({approvebtn : true, reactivatebtn: false, deletebtn: false,userid: value.id });
    }
    this.setState({companyname: value.companyName})

  }

  setDisableupload = (val)=>{
    this.setState({disableupload : val})
  }

  setPrjName = (name)=>{
    this.setState({projectName : name});
  }

  setDisableUploadBack = (val)=>{
    this.setState({disableUploadBack : val});
  }

  setUploadcontent = (s)=>{
    this.setState({uploadcontent:s});
  }

  checkuploadinlist = (prj,type)=>{};

  showNPuploadFlase= ()=>{
    this.setState({showUpload : false});
    messages = defineMessages({
      htmlHeader: {
        id: 'preview.html.header',
        description:
          'The title of the page that appears in the html header of the page.',
        defaultMessage: 'Preview'
      },
      headerTitle: {
        id: 'snowflake.home.title',
        description: 'Page Header Title',
        defaultMessage: 'Home'
      },
      headerSubTitle: {
        id: 'empty',
        description: 'Page Header Subtitle',
        defaultMessage: ''
      },
      searchFiles: {
        id: 'preview.search.files',
        description: 'search files',
        defaultMessage: 'Search Files'
      },
      alertTitle: {
        id: 'preview.alert.title',
        description: 'Preview API alert title',
        defaultMessage: 'Loading Project Files Failed'
      }
    });
    this.props.RequestList(this.props.username);
  }

  showNPuploadTrue= ()=>{
    this.setState({showUpload : true});
    messages = defineMessages({
      htmlHeader: {
        id: 'preview.html.header',
        description:
          'The title of the page that appears in the html header of the page.',
        defaultMessage: 'Preview'
      },
      headerTitle: {
        id: 'snowflake.home.upload',
        description: 'Page Header Title',
        defaultMessage: 'Home'
      },
      headerSubTitle: {
        id: 'snowflake.home.upload.sub',
        description: 'Page Header Subtitle',
        defaultMessage: 'Finalize project details to generate your Analyzer Report'
      },
      searchFiles: {
        id: 'preview.search.files',
        description: 'search files',
        defaultMessage: 'Search Files'
      },
      alertTitle: {
        id: 'preview.alert.title',
        description: 'Preview API alert title',
        defaultMessage: 'Loading Project Files Failed'
      }
    });
  }

  selectCus = (e)=>{
    this.setState({customer : e.target.value});
    this.props.NPRequestList(e.target.value);
  }

  openModal = ()=>{};

  refresh = ()=>{
    setTimeout(() => {
      window.location.reload()();
    }, 500)
  }

  approve =()=>{
    const msg = `The organization ${this.state.companyname} has been approved. An email notification has been sent to the organization’s admin user.`
    this.setState({confirmationText : msg, modalsize: "modal_sm"});
    this.props.customerApprove(this.state.userid,this.openModal);
  };

  deactivate =()=>{
    const msg = `The organization ${this.state.companyname} has been deleted. An email notification has been sent to the organization’s admin user.`
    this.setState({confirmationText : msg, modalsize: "modal_sm"});
    this.props.customerdeactivate(this.state.userid,this.openModal);
  };

  reactivate =()=>{
    const msg = `The organization ${this.state.companyname} has been reactivated. An email notification has been sent to the organization’s admin user.`
    this.setState({confirmationText : msg, modalsize: "modal_sm"});
    this.props.customerrectivate(this.state.userid,this.openModal)
  };

  help = ()=>{
    const msg = "          <ul class='marginLeft20'>\n" +
      "            <li><b>Analyzer Report (Free)</b> - The SHIFT Analyzer Report will assess the translation capabilities of the SHIFT Translator on your legacy code. </li>\n" +
      "            <ul class='marginLeft20'>\n" +
      "              <li>The free SHIFT Analyzer Report will be limited to 10,000 lines of SQL code</li>\n" +
          "            <ul class='marginLeft20'>\n" +
          "              <li>Based on 90 characters per line standard\n</li>\n" +
          "            </ul>\n" +
      "              <li>1000-line translated code\n</li>\n" +
      "            </ul>\n" +
      "            <li><b>Analyzer Report (Pro) </b> - The SHIFT Analyzer Report will assess the translation capabilities of the SHIFT Translator on your legacy code. Contact us to request for paid Analyzer Report.\n </li>\n" +
      "            <li><b>Translate Files </b> - A Commercial Code Translation will translate the full fidelity of your legacy code to the target language. Contact us to request for paid commercial code translation. </li>\n" +
      "          </ul>";
    this.setState({confirmationText : msg, modalsize: "modal_lg"});
    this.openModal();
  }

  sourceCodedownload = (requesttype)=>{
    console.log(this.state.stagingrepo);
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    // /shift/sampleproject/{requesttype}
    // requesttype can be : sourcecode
    // freeassessment
    // proassessment
    // translation

    fetch(`${config.protocol}://${config.host}/api/shift/sampleproject/${requesttype}`, requestOptions)
      .then(response =>
      {
        console.log(response)
        return response.blob()
      })
      .then(data => {
        console.log(data)
        const FileDownload = require("js-file-download");
        FileDownload(data, requesttype + ".zip");
      }).catch(err => console.log(err));
  }

  render() {
    return (
      <div className={this.state.show ?"pageHide": "page"}>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="projects"
          locale={this.props.locale}
          status = {this.props.status}
        />
        <ModalExample
          hasTitle
          info
          infoText = "SHIFT Details"
          className={this.state.modalsize}
          reset={()=>{this.refresh()}}
          setClick={click => this.openModal = click}
          content={this.state.confirmationText}/>

          { !this.props.role.includes('ACCOUNT_APPROVER') &&  (this.props.role.includes('PROFESSIONAL_SERVICE') || this.props.role.includes('CUSTOMER_ADMIN')) &&(
            <div
              className="main"
            >
              <div
                className="panel"
                style={{
                  width: '60%',
                  padding: '40px',
                  boxSizing: 'content-box',
                  marginTop: '15px',
                  display: 'block',
                  alignItems: 'center',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  overflow: "auto"
                }}
              >
                {!this.state.showUpload && (
                  <div>
                    {/* <UserTable data={this.props.transactions} type="customer" sample={this.sourceCodedownload}/> */}
                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <button className="button" style={{ marginRight: '20px' }}
                              onClick={()=>this.showNPuploadTrue()}
                      >
                        Upload New
                      </button>
                      <button className="button" style={{ marginRight: '20px' }}
                              onClick={()=>this.help()}
                      >
                        Help
                      </button>
                    </div>
                  </div>
                  )}

                  {this.state.showUpload ? (
                    <div className="form">
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="source.code.project.name"
                          defaultMessage="Project Name"
                        />
                      </label>
                      <Control.text
                        model=".projectName"
                        value={this.state.projectName}
                        placeholder={this.state.uploadType==='upload' ?"same as zip file name" : ""}
                        disabled
                      />

                      <br />
                      <br />
                      <br />
                      {MyUploader(this.state.projectName,this.props.username,this.state.uploadType,
                        "customer",null,this.props.customerid,this.state.uploadcontent,this.setUploadcontent,
                        this.setDisableUploadBack,this.setPrjName,this.checkuploadinlist,this.state.disableUploadBack,
                        this.state.disableupload,this.setDisableupload
                      )}
                      <br />
                      <br />
                      <br />
                      <div className="button-container" style={{ textAlign: 'center' }}>
                        <button
                          className="button"
                          type="button"
                          style={{ marginRight: '40px' }}
                          onClick={()=>this.showNPuploadFlase()}
                          disabled={this.state.disableUploadBack}
                        >
                          back
                        </button>
                      </div>
                    </div>
                  ) : null}
              </div>
            </div>
            )}

          { !this.props.role.includes('ACCOUNT_APPROVER') &&  (this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER'))  &&(
            <div
              className="main"
              style={{
                alignItems: 'center',
                overflow: "auto"
              }}
            >
              <div
                className="panel"
                style={{
                  width: '60%',
                  padding: '40px',
                  boxSizing: 'content-box',
                  // marginTop: '15px',
                  display: 'block',
                  alignContent: 'center',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
               <div className="form">
                <fieldset style={{padding: '20px', width: "auto", float:"none"}}>
                  <label style={{ textTransform: 'capitalize' }}>
                    <FormattedMessage
                      id="dashboard.customer"
                      defaultMessage="Organization Name: "
                    />
                  </label>

                  <Control.select
                    model=".customer"
                    autoFocus
                    required
                    value={this.state.customer}
                    onChange={this.selectCus}
                  >
                    {this.state.customer === "" && <option value="">Please select organization name</option>}
                    {this.props.customersList.map(item => (
                      <option key={item["customer_id"]} value={item["customer_id"]}>
                        {item["company_name"]}
                      </option>
                    ))}
                  </Control.select>

                </fieldset>

                {/* {this.state.customer && (
                    <UserTable data={this.props.transactions} type="np" customer={this.state.customer} />
                )} */}
              </div>
              </div>
            </div>
          )}

          {  this.props.role.includes('ACCOUNT_APPROVER')  &&(
            <div
              className="main"
              style={{
                alignItems: 'center',
                overflow: "auto"
              }}
            >
              <Approver data={this.props.usersapproveList} selectItem={this.selectItem} />

              <br/>
              <br/>
              <div
                className="button-container"
                style={{ textAlign: 'center' }}
              >
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={() => this.approve()}
                  disabled={!this.state.approvebtn}
                >
                  APPROVE
                </button>
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={() => this.reactivate()}
                  disabled={!this.state.reactivatebtn}
                >
                  REACTIVATE
                </button>
                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={() => this.deactivate()}
                  disabled={!this.state.deletebtn}
                >
                  Delete
                </button>
              </div>
            </div>
          )}

{/* <div> <button className="button" style={{ marginRight: '20px' }} onClick={this.props.gotoDatafactorymanagement}>
                  test
                 </button>
                            
                 </div> */}

          {/*for customer*/}
          {/*{  (this.props.role.includes('PROFESSIONAL_SERVICE') || this.props.role.includes('CUSTOMER_ADMIN')) &&(*/}
          {/*  <Container style={{marginTop: '90px'}}>*/}
          {/*    <Row>*/}
          {/*      <Col xs="4" >*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              Free Analyzer Report*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              The SHIFT Analyzer Report will assess the translation capabilities of SHIFT Translator on your legacy code.*/}
          {/*              <br/>*/}
          {/*              <br/>*/}
          {/*              Each client can run a 1-time {' '}*/}
          {/*              <i><b>Free SHIFT Analyzer Report - </b></i>*/}
          {/*              <ModalExample hasTitle*/}
          {/*                            info*/}
          {/*                            infoText="Free Analyzer Report Offer Details"*/}
          {/*                            className="modal_lg"*/}
          {/*                            isText*/}
          {/*                            content={offerDetails}*/}
          {/*              />*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*            onClick={() =>{*/}
          {/*              this.props.gitlabProjects(*/}
          {/*                this.props.username,*/}
          {/*                "free"*/}
          {/*              )}*/}
          {/*            }*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}
          {/*      <Col xs="4" >*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              Analyzer Report*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              The SHIFT Analyzer Report will assess the translation capabilities of SHIFT Translator on your legacy code{' '}*/}
          {/*              <i className="textUnderline">including a list of exceptions.</i>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*            onClick={() =>{*/}
          {/*                this.props.gitlabProjects(*/}
          {/*                  this.props.username,*/}
          {/*                  "standard"*/}
          {/*                )}*/}
          {/*            }*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}
          {/*      <Col xs="4">*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              Commercial Code Translation*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              A Commercial Code Translation will translate the full fidelity of your legacy code to the target language.*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*            onClick={() =>{*/}
          {/*              this.props.gitlabProjectsForTrans(*/}
          {/*                this.props*/}
          {/*              )}*/}
          {/*            }*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}
          {/*      <Col xs="4">*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              Dashboard*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              View the status of your submitted Analyzer Reports and Commercial Code Translations and download your Analyzer Report or Translated Source Code.*/}

          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*                  onClick={this.props.gotoDashboard}*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}

          {/*      { this.props.role.includes('CUSTOMER_ADMIN') &&(*/}
          {/*        <Col xs="4">*/}
          {/*          <div className={panel_home} style={{backgroundColor: 'rgba(0,123,255,.25)'}}>*/}
          {/*            <div className="form">*/}
          {/*              <div className="homeboxTitle">*/}
          {/*                User Management*/}
          {/*              </div>*/}
          {/*              <div className="homebox">*/}
          {/*                Add / Delete users.*/}
          {/*              </div>*/}
          {/*            </div>*/}
          {/*            <button className={homebox_button}*/}
          {/*              onClick={this.props.gotoManagement}*/}
          {/*            >*/}
          {/*              <FormattedMessage*/}
          {/*                id="readyToGo.button.name"*/}
          {/*                defaultMessage="Ready to Go"*/}
          {/*              />*/}
          {/*            </button>*/}
          {/*          </div>*/}
          {/*        </Col>*/}
          {/*      )}*/}
          {/*    </Row>*/}
          {/*  </Container>*/}
          {/*)}*/}

          {/*/!*for np user*!/*/}
          {/*{(this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER'))  &&(*/}
          {/*  <Container style={{marginTop: '90px'}}>*/}
          {/*    <Row>*/}
          {/*      <Col xs="4" >*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              Free Analyzer Report*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              The SHIFT Analyzer Report will assess the translation capabilities of SHIFT Translator on your legacy code.*/}
          {/*              <br/>*/}
          {/*              <br/>*/}
          {/*              Each client can run a 1-time {' '}*/}
          {/*              <i><b>Free SHIFT Analyzer Report - </b></i>*/}
          {/*              <ModalExample hasTitle*/}
          {/*                            info*/}
          {/*                            infoText="Free Analyzer Report Offer Details"*/}
          {/*                            className="modal_lg"*/}
          {/*                            isText*/}
          {/*                            content={offerDetails}*/}
          {/*              />*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*                  onClick={() =>{*/}
          {/*                    this.props.gitlabProjects(*/}
          {/*                      this.props.username,*/}
          {/*                      "free"*/}
          {/*                    )}*/}
          {/*                  }*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}
          {/*      <Col xs="4" >*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              Analyzer Report*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              The SHIFT Analyzer Report will assess the translation capabilities of SHIFT Translator on your legacy code{' '}*/}
          {/*              <i className="textUnderline">including a list of exceptions.</i>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*                  onClick={() =>{*/}
          {/*                      this.props.gitlabProjects(*/}
          {/*                        this.props.username,*/}
          {/*                        "standard"*/}
          {/*                      )}*/}
          {/*                  }*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}
          {/*      <Col xs="4">*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              Commercial Code Translation*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              A Commercial Code Translation will translate the full fidelity of your legacy code to the target language.*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*                  onClick={() =>{*/}
          {/*                    this.props.gitlabProjectsForTrans(*/}
          {/*                      this.props*/}
          {/*                    )}*/}
          {/*                  }*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}
          {/*      <Col xs="4">*/}
          {/*        <div className={panel_home}>*/}
          {/*          <div className="form">*/}
          {/*            <div className="homeboxTitle">*/}
          {/*              DashBoard*/}
          {/*            </div>*/}
          {/*            <div className="homebox">*/}
          {/*              View the status of your submitted Analyzer Reports and Commercial Code Translations and download your Analyzer Report or Translated Source Code.*/}

          {/*            </div>*/}
          {/*          </div>*/}
          {/*          <button className={homebox_button}*/}
          {/*                  onClick={this.props.gotoDashboard}*/}
          {/*          >*/}
          {/*            <FormattedMessage*/}
          {/*              id="readyToGo.button.name"*/}
          {/*              defaultMessage="Ready to Go"*/}
          {/*            />*/}
          {/*          </button>*/}
          {/*        </div>*/}
          {/*      </Col>*/}

          {/*      { this.props.role.includes('CUSTOMER_ADMIN') &&(*/}
          {/*        <Col xs="4">*/}
          {/*          <div className={panel_home} style={{backgroundColor: 'rgba(0,123,255,.25)'}}>*/}
          {/*            <div className="form">*/}
          {/*              <div className="homeboxTitle">*/}
          {/*                User Management*/}
          {/*              </div>*/}
          {/*              <div className="homebox">*/}
          {/*                Add / Delete users*/}
          {/*              </div>*/}
          {/*            </div>*/}
          {/*            <button className={homebox_button}*/}
          {/*                    onClick={this.props.gotoManagement}*/}
          {/*            >*/}
          {/*              <FormattedMessage*/}
          {/*                id="readyToGo.button.name"*/}
          {/*                defaultMessage="Ready to Go"*/}
          {/*              />*/}
          {/*            </button>*/}
          {/*          </div>*/}
          {/*        </Col>*/}
          {/*      )}*/}
          {/*    </Row>*/}
          {/*  </Container>*/}
          {/*)}*/}

        {/*</div>*/}

        <Footer />
      </div>
    );
  }
}

Snowflake.propTypes = {
  gitlabProjects: PropTypes.func.isRequired,
  gitlabProjectsForTrans: PropTypes.func.isRequired,
  groupId: PropTypes.string,
  gitlab_id: PropTypes.string,
  role: PropTypes.string
};

export default injectIntl(Snowflake);



// WEBPACK FOOTER //
// ./src/components/views/Snowflake/index.js